import React from 'react';
import c from 'classnames';

import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';
import { Icon } from '@uncinc/uncinc-react-kitchen-sink';
import type { AspectRatio } from '@uncinc/react-drupal-core/dist/Components/DynamicMediaItem';

import type { MediaReferenceField } from '../../../types/uncinc_profile/helpers/media';

import './style.scss';

type Props = {
  title: string,
  label?: string,
  link: string,
  image?: MediaReferenceField<'image'>,
  aspectRatio?: AspectRatio;
  icon?: string,
  titleClassName?: string,
};

const LinkListPrimaryItem: React.FC<Props> = (props) => {
  const {
    title,
    label,
    link,
    image,
    aspectRatio = '1_1',
    icon,
    titleClassName,
  } = props;

  const titleClasses = c('LinkListItem__title', titleClassName);

  return (
    <li className="LinkListItem">
      <CoreLink className="LinkListItem__link" href={link} title={title}>

        {image && (
          <div className="LinkListItem__image">
            <DynamicMediaItem
              media={image}
              imageAspectRatio={aspectRatio}
              alt={title}
            />
          </div>
        )}

        <div className="LinkListItem__text">
          <div className="LinkListItem__text__content">
            <span className={titleClasses}>{title}</span>
            {label && (
              <span className="LinkListItem__label">{label}</span>
            )}
          </div>
          {icon && (
            <Icon name={icon} flair="outlined" />
          )}
        </div>

      </CoreLink>
    </li>
  );
};

export default LinkListPrimaryItem;
